interface FieldErrorProps {
  message?: string;
}

export const FieldError = ({ message }: FieldErrorProps) => {
  if (!message) return null;

  return <p className='mt-1 text-sm text-destructive'>{message}</p>;
};
